import { render } from "./MenuRendimientos.vue?vue&type=template&id=3c1e24cd"
import script from "./MenuRendimientos.vue?vue&type=script&lang=js"
export * from "./MenuRendimientos.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/tesoreria_tolima/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__